import { ShoppingCart } from 'lucide-react';

export function StepCartEmptyState() {
  return (
    <div className="flex min-h-60 flex-col items-center justify-center rounded-md border bg-white px-6 py-12 text-center">
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-gray-100">
        <ShoppingCart className="h-6 w-6 text-gray-400" aria-hidden="true" />
      </div>
      <h2 className="text-base font-semibold">Seu carrinho está vazio</h2>
      <p className="mt-2 max-w-sm text-sm text-muted-foreground">
        Use o botão “Adicionar itens ao carrinho” para incluir os produtos desta proposta.
      </p>
    </div>
  );
}
